"use client";

import { pdf } from "@react-pdf/renderer";
import type { FullViewResume } from "@/_models/resume";
import { DefaultAtsPdfDocument } from "./pdf/templates/DefaultAtsPdfDocument";

/**
 * Renders the ATS resume with @react-pdf/renderer and triggers a browser download.
 * @see https://react-pdf.org/advanced#on-the-fly-rendering
 */
export async function downloadAtsResumePdf(
  data: FullViewResume,
  filename: string,
): Promise<void> {
  const instance = pdf(
    <DefaultAtsPdfDocument jobDetails={data.resume.job_details} />,
  );
  const blob = await instance.toBlob();
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.rel = "noopener";
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
